<template>
  <v-textarea
    :outlined="outlined"
    v-bind="$attrs"
    @input="updateFieldValue(name, $event)"
    :value="currentValue"
    :messages="[error]"
    :error="!!error"
  ></v-textarea>
</template>
<script>
import baseInput from "./baseInput";
export default {
  props: {
    outlined: {
      default: true,
      type: Boolean,
    },
  },
  mixins: [baseInput],
};
</script>
